const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

class BrokerMarketsCalendarDatePickerButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onStateChange({
            index: this.props.index
        });
    }

    render() {
        const { hasEvents, index, extraClass } = this.props;

        let classButton = classNames(
            'broker-markets-calendar-date-picker__button',
            {
                'broker-markets-calendar-date-picker__button--active': this.props.isActive,
                'broker-markets-calendar-date-picker__button--empty': hasEvents,
                'broker-markets-calendar-date-picker__button--disabled': index === 6,
                [extraClass]: !!extraClass
            }
        );

        return (
            <button
                index={index}
                className={classButton}
                onClick={this.handleClick}
            >
                {this.props.children}
            </button>
        );
    }
}

BrokerMarketsCalendarDatePickerButton.propTypes = {
    onStateChange: PropTypes.func,
    isActive: PropTypes.bool,
    hasEvents: PropTypes.bool,
    index: PropTypes.number,
    extraClass: PropTypes.string,
    children: PropTypes.any
}

BrokerMarketsCalendarDatePickerButton.defaultProps = {
    onStateChange: function(){},
    isActive: false,
    hasEvents: false,
    index: 0,
    extraClass: ''
}

module.exports = BrokerMarketsCalendarDatePickerButton;